export default function Social({ className }) {
    return <div className={`${className}`}></div>;
}
